import firebase from 'firebase/app'


const getClients = async (options = {}) => {
  const db = firebase.firestore()
  let snapshots = db.collection('clients')
    .orderBy(options.orderBy || 'created_at', options.direction || 'desc')

  if (options.createdAt) {
    snapshots = snapshots.where('created_at', '>', options.createdAt)
  }

  if (options.startAfter) {
    snapshots = snapshots.startAfter(options.startAfter)
  } else if (options.endBefore) {
    snapshots = snapshots.endBefore(options.endBefore)
  }

  snapshots = await snapshots.get()

  return snapshots.docs.map((doc) => {
    const data = doc.data()

    return {
      id: doc.id,
      ...data,
      created_at: data.created_at && data.created_at.toDate(),
    }
  })
}


export default getClients
